export enum SelfServiceSlotStatus {
  ASSIGNED = 'ASSIGNED',
  PRE_UNASSIGNED = 'PRE_UNASSIGNED',
  UNASSIGNED = 'UNASSIGNED',
}

export interface Slot {
  id: string;
  rack: number;
  used: boolean;
  position: number;
  lastName?: string;
  firstName?: string;
  finalized?: boolean;
  displayName?: string;
  referenceId?: string;
  registration?: string;
  selfServiceId?: string;
  selfServiceType?: string;
  status: SelfServiceSlotStatus;
}
